<template>
  <div class="dashboard-skeleton-loader">
    <stage-card-skeleton-loader
      title="Title &amp; Abstract Screening"
      :columns="3"
    />
    <stage-card-skeleton-loader
      title="Full Text Review"
      :columns="2"
    />
    <stage-card-skeleton-loader
      title="Data Extraction"
      :columns="2"
    />
  </div>
</template>

<script>
import StageCardSkeletonLoader from './StageCardSkeletonLoader';

export default {
  name: 'DashboardSkeletonLoader',
  components: { StageCardSkeletonLoader },
};
</script>

<style lang="scss" scoped>
.dashboard-skeleton-loader {
  display: grid;
  gap: 24px;

  max-width: 1300px;
  width: 100%;
}
</style>
